var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirbnbSearchScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.airbnb-search{fill:url(#airbnb-search-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "airbnb-search-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbbab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30442,
    stopColor: "#ff6a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ff385c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f2e50"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "airbnb-search",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M50.34863,62.08936c-4.92578,0-8.93311-4.00732-8.93311-8.93262,0-4.92578,4.00732-8.93311,8.93311-8.93311s8.93311,4.00732,8.93311,8.93311c0,4.92529-4.00732,8.93262-8.93311,8.93262ZM50.34863,47.22363c-3.27148,0-5.93311,2.66162-5.93311,5.93311s2.66162,5.93262,5.93311,5.93262,5.93311-2.66113,5.93311-5.93262-2.66162-5.93311-5.93311-5.93311Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M38.80273,72.46875c-2.21631,0-4.33936-.77441-6.0249-1.98779-3.51221-2.52881-5.81982-7.46777-3.05811-12.80127l13.29297-26.15283c1.31445-2.58545,3.93213-4.19873,6.83252-4.20996h.03027c2.88867,0,5.50537,1.59082,6.83496,4.15771l13.56982,26.20508c2.14014,4.1333,1.40771,8.67285-1.91162,11.84814-3.31592,3.17139-8.0957,3.83398-11.89258,1.64844-1.28369-.73877-2.40576-1.8623-3.33594-3.33936l-4.06104-6.44824,2.53906-1.59863,4.06055,6.44824c.6665,1.05908,1.43848,1.84521,2.29395,2.33789,3.04053,1.74951,6.37158.65088,8.32227-1.21631,2.35303-2.25098,2.84717-5.354,1.32129-8.30029l-13.56982-26.20508c-.82324-1.58984-2.38135-2.5376-4.16992-2.5376h-.01953c-1.79688.00684-3.35547.96729-4.16943,2.56934l-13.29834,26.16309c-1.94434,3.75439-.32422,7.22168,2.1416,8.99707,2.46533,1.77441,6.26709,2.21191,9.20361-.81494l1.75439-1.83936,2.1709,2.07031-1.76318,1.84863c-2.17969,2.24707-4.69141,3.15723-7.09375,3.15771Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirbnbSearchScraper);
export default __webpack_public_path__ + "static/media/airbnb-search-scraper.7ff9d1fccd6e3bf1f23c77a72ee85ad4.svg";
export { ForwardRef as ReactComponent };